import { useLanguage } from "../../i18n/language-provider";
import { WELCOME_FOUNDER } from "./welcomePeople";

interface AboutSectionProps {
    /** The anchor the header's link points at. */
    id: string;
}

/**
 * "Who we are": the founders' story, told by one of them in his own words and
 * signed with his name and portrait. It is a quotation, so it is marked up as
 * one — the story in a blockquote, the signature as its caption.
 */
export function AboutSection({ id }: AboutSectionProps) {
    const { t } = useLanguage();
    const w = t.welcome;
    const { name, portrait } = WELCOME_FOUNDER;

    return (
        <section id={id} className="scroll-mt-20 border-t">
            <figure className="mx-auto grid max-w-6xl gap-10 px-6 py-20 lg:grid-cols-12 lg:gap-12 lg:py-24">
                <div className="lg:col-span-5">
                    <p className="type-eyebrow">{w.navAbout}</p>
                    <h2 className="type-display-section mt-3 text-3xl text-balance">{w.aboutTitle}</h2>

                    {/* Beside the signature on a phone, where a tall portrait
                        would push the story a screen down; above it from lg,
                        where the column has the room. */}
                    <figcaption className="mt-8 flex items-center gap-4 lg:mt-10 lg:flex-col lg:items-start">
                        <img
                            src={portrait.src}
                            alt={name}
                            width={portrait.width}
                            height={portrait.height}
                            loading="lazy"
                            decoding="async"
                            className="aspect-[3/4] h-auto w-24 shrink-0 rounded-lg border object-cover sm:w-28 lg:w-52"
                        />
                        <div className="min-w-0">
                            <p className="font-medium">{name}</p>
                            <p className="text-sm text-muted-foreground">{w.aboutRole}</p>
                        </div>
                    </figcaption>
                </div>

                <blockquote className="space-y-4 leading-relaxed lg:col-span-7">
                    {w.aboutStory.map((paragraph) => (
                        <p key={paragraph}>{paragraph}</p>
                    ))}
                    <p className="type-display-section pt-2 text-xl text-emphasis">{w.aboutClosing}</p>
                </blockquote>
            </figure>
        </section>
    );
}
